import { DateRange } from 'react-day-picker';
import { QueryFunctionContext, useQuery } from '@tanstack/react-query';
import { axiosInstance } from 'api/axios';
import { routes } from 'api/routes';
import { getAnalyticsDateParams } from '../functions';
import { ChannelAnalytics } from './types';

const get = async ({
  queryKey,
}: QueryFunctionContext<[string, number, DateRange]>) => {
  const [, appId, date] = queryKey;
  const params = getAnalyticsDateParams(date);
  if (!params) return null;

  const { data } = await axiosInstance.get<ChannelAnalytics[]>(
    `${routes['analytics']}/apps/${appId}/channels`,
    {
      params,
    },
  );

  return data;
};

const useGetChannelAnalytics = (appId: number, date: DateRange) => {
  return useQuery({
    queryKey: [`${routes['analytics']}/channel`, appId, date],
    queryFn: get,
    enabled: Boolean(appId),
  });
};

export default useGetChannelAnalytics;
